/**
 * Created by andrey on 07.08.2025
 */

cc.ENABLE_STACKABLE_ACTIONS = true;

cc.FLT_EPSILON = 0.0000001192092896;

cc.ActionManager = function () {
    this.actions = {};
    this.paused = {};
};

cc.ActionManager.prototype.getKey = function (target) {
    return `${target.__instanceId}`;
};

cc.ActionManager.prototype.addAction = function (action, target, paused) {
    const key = this.getKey(target);

    let actions = this.actions[key];
    if (!actions) {
        this.actions[key] = actions = [];
    }

    if (paused) {
        this.paused[key] = true;
    }

    actions.push(action);

    action.startWithTarget(target);
};

cc.ActionManager.prototype.removeAllActionsFromTarget = function (target, autoFinalize) {
    const key = this.getKey(target);

    const actions = this.actions[key];
    delete this.paused[key];

    if (actions) {
        delete this.actions[key];

        for (let index = 0; index < actions.length; index++) {
            const action = actions[index];
            if (action) {
                actions[index] = undefined;
                action.finalize(autoFinalize);
            }
        }
        actions.length = 0;
    }
};

cc.ActionManager.prototype.removeAction = function (action, autoFinalize) {
    if (!action) {
        return;
    }
    
    const target = action.getOriginalTarget();
    const key = this.getKey(target);
    const actions = this.actions[key];

    if (!actions) {
        return;
    }

    const index = actions.indexOf(action);
    if (index !== -1) {
        actions[index] = undefined;
        action.finalize(autoFinalize);
    }
};

cc.ActionManager.prototype.removeActionByTag = function (tag, target) {
    const action = this.getActionByTag(tag, target);
    if (action) {
        this.removeAction(action);
    }
};

cc.ActionManager.prototype.getActionByTag = function (tag, target) {
    const key = this.getKey(target);
    const actions = this.actions[key];
    return actions && actions.find((action) => action && action.getTag() === tag);
};

cc.ActionManager.prototype.numberOfRunningActionsInTarget = function (target) {
    const key = this.getKey(target);
    const actions = this.actions[key];

    if (!actions) {
        return 0;
    }

    let count = 0;
    for (let index = 0; index < actions.length; index++) {
        const action = actions[index];
        if (action) {
            count++;
        }
    }
    return count;
};

cc.ActionManager.prototype.listRunningActions = function (target) {
    const key = this.getKey(target);
    const actions = this.actions[key];

    if (!actions) {
        return [];
    }

    return actions.filter((action) => action && !action.isDone());
};

cc.ActionManager.prototype.pauseTarget = function (target) {
    const key = this.getKey(target);
    this.paused[key] = true;
};

cc.ActionManager.prototype.resumeTarget = function (target) {
    const key = this.getKey(target);
    delete this.paused[key];
};

cc.ActionManager.prototype.update = function (dt) {
    let index, length, action, actions;

    for (const key in this.actions) {
        if (this.paused[key]) {
            continue;
        }

        actions = this.actions[key];

        for (index = 0; index < actions.length; index++) {
            action = actions[index];
            action && action.step(dt);

            action = actions[index];
            if (action && action.isDone()) {
                actions[index] = undefined;
                action.stop();
                action.finalize();
            }
        }

        for (length = 0, index = 0; index < actions.length; index++) {
            if (actions[index]) {
                actions[length++] = actions[index];
            }
        }

        actions.length = length;

        actions = this.actions[key];

        if (actions && actions.length === 0) {
            delete this.actions[key];
        }
    }
};
